/**
 *  页面组件 装箱单/随车单
 * @author FJJ
 * History:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2022/09/14      1.0    First version   使用统一的表格组件
 *
 * @copyright 2021-2022, all rights reserved. Essa.cn
 * */

import React,{Fragment} from 'react'
import {  Spin, Table} from 'antd';
import Lang from "@components/Lang/Lang";
import AutoFetchTable from "@/components/AutoFetchTable/AutoFetchTable";
import PropTypes from "prop-types";
import History from "./History";
import {toFixed2} from '@utils/utils';
import DownloadBtnModal from "./DownloadBtnModal";
import HistoryBtnModal from './HistoryBtnModal';
import ConfirmAlert from './ConfirmAlert'
import {getInfo,getSampleColumns,getTotal} from "./Info";
import PageCommon from  "@components/PageCommon/PageCommon";

export default class CommonPage extends React.Component{
    static propTypes = {
        orderType: PropTypes.string.isRequired,
    }
    static defaultProps = {
        orderType:'',
        pageTitle:''
    }
    constructor(props) {
        super(props);
        this.state = {
            list:[],
            orderInfo: {},
            loading:false,
            //历史记录面板
            isShowHistoryPanel:false,
            isShowHistoryId:null,
            // 列
            columns : getSampleColumns(props.orderType)

        }
    }
    getData(){
        this.onRefTabChildOne.handleFetch(1,{},true)
    }
    /**
     * 展示历史记录面板
     * @param item
     */
    showHistoryPanel(item){
        this.setState({
            isShowHistoryPanel:true,
            isShowHistoryId:item.id,
        })
    }

    /**
     * 隐藏历史记录面板
     **/
    hideHistoryPanel(){
        this.setState({
            isShowHistoryPanel:false,
        })
    }
    /**
     * 加载状态
     * */
    loading(flag) {
        this.setState({
            loading: flag,
        });
    }
    /**
     * 设置 信息头
     * */
    setOrderInfo(res){
        if(res&&res.model&&res.model.orderInfo)this.setState({
            orderInfo:res.model.orderInfo
        })
        if(this.props.fetchCallBack)this.props.fetchCallBack(res); // 回调到管理页
    }
    onRefTabOne = (ref) =>  this.onRefTabChildOne = ref;
    componentDidMount() {
        if(this.props.onRef)this.props.onRef(this);
    }

    componentWillUnmount(){
        this.setState = (state, callback) => {
            return;
        }
    }

    onRefPageCommon = (ref) => this.onRefPageCommonChild = ref; 
    render(){
        const { orderInfo,loading,columns, isShowHistoryPanel,  } = this.state;
        const {orderType,containerId,pageTitle,scroll,downloadUrlExcel,downloadUrlPdf,fetchApi} = this.props;

        let btnList;
        if(!isShowHistoryPanel){
            btnList= [
                { 
                    btn: <DownloadBtnModal title={<div>
                        <i className='ri-download-2-line color-blue mr_4'></i>
                        {Lang({id: "XiaZaiExcel",default: "下载Excel"})}
                    </div> }
                    downloadUrl={downloadUrlExcel}
                    orderInfo={orderInfo} />,
                    btnClick:()=>{}
                },{ 
                    btn: <DownloadBtnModal title={<div>
                        <i className='ri-download-2-line color-danger mr_4'></i>
                        {Lang({id: "XiaZaiGaiZhangPDF",default: "下载盖章PDF"})}
                    </div>}
                    downloadUrl={downloadUrlPdf}
                    orderInfo={orderInfo} type={'pdf'} />,
                    btnClick:()=>{}
                },{ 
                    btn: <HistoryBtnModal className={"margin-left-5"}
                    title={pageTitle+Lang({id: 'LiShiJiLu', default: '历史记录'})}
                    orderType={orderType}
                    recoveryHistoryBack={this.getData.bind(this)}
                    showHistoryPanel={item=>this.showHistoryPanel(item)}
                    containerId={containerId} />,
                    btnClick:()=>{}
                }
            ]
    
    
            if(orderInfo.status === '10' || orderInfo.status === '20'){
                btnList.push({
                    btn: <ConfirmAlert orderInfo={orderInfo} orderType={orderType} callBack={()=>this.getData()} />,
                    btnClick:()=>{}
                })
            }
        }

        
        return (
            <PageCommon onRef={this.onRefPageCommon} className={"transferWrap"} btnList={btnList}>
                <div className={"packListWrap"}>
                    {isShowHistoryPanel?<History id={this.state.isShowHistoryId} orderType={orderType}
                                                loading={loading}
                                                title={pageTitle}
                                                columns = {columns}
                                                scroll={scroll}
                                                callBackFields = {['model','orderItemList']}
                                                fetchApi={fetchApi}
                                                callBack={this.hideHistoryPanel.bind(this)} />:<Spin spinning={loading}>
                                        <AutoFetchTable columns={columns}
                                                        callBackFields = {['model','orderItemList']}
                                                        paginationFlag={false}
                                                        onRef={this.onRefTabOne}
                                                        bordered={true}
                                                        rowClassName={(record, index)=>{return record.isSign?"is-sign-bg":""}}
                                                        summary={(orderType=='trucking'||orderType=='trucking_sub')?getTotal:null}
                                                        scroll={scroll||{y:450}}
                                                        fetchCallBack={(res)=>this.setOrderInfo(res)}
                                                        precondition={{containerId:containerId}}
                                                        fetchApi={fetchApi}>
                                        {orderInfo&&orderInfo.id&&<div>
                                            {/*操作区*/}
                                            {/* <div className={"flex-item fixed-footer__wrap"}>
                                                <DownloadBtnModal title={Lang({id: "XiaZaiExcel",default: "下载Excel"})}
                                                                downloadUrl={downloadUrlExcel}
                                                                orderInfo={orderInfo} />
                                                <DownloadBtnModal title={Lang({id: "XiaZaiGaiZhangPDF",default: "下载盖章PDF"})}
                                                                className={"margin-left-5"}
                                                                downloadUrl={downloadUrlPdf}
                                                                type={'pdf'}
                                                                orderInfo={orderInfo} />
                                                <HistoryBtnModal className={"margin-left-5"}
                                                                title={pageTitle+Lang({id: 'LiShiJiLu', default: '历史记录'})}
                                                                orderType={orderType}
                                                                recoveryHistoryBack={this.getData.bind(this)}
                                                                showHistoryPanel={item=>this.showHistoryPanel(item)}
                                                                containerId={containerId} />
                                                <ConfirmAlert orderInfo={orderInfo} orderType={orderType} callBack={()=>this.getData()} />
                                            </div> */}
                                            {/* 表头 */}
                                            {getInfo(orderType,orderInfo)}
                                            {/* 表头 END */}
                                        </div>}
                                    </AutoFetchTable>
                                </Spin>}
                </div>
            </PageCommon>

        )
    }
}
